export const SCENARIO_TYPES = [
  {
    value: 'inbound',
    label: '↓ Inbound',
    displayName: 'Inbound',
    color: 'success.light',
    borderColor: 'success.light',
  },
  {
    value: 'outbound-kochava',
    label: '↗ Kochava',
    displayName: 'Outbound (Kochava)',
    color: 'text.secondary',
    borderColor: 'text.secondary',
  },
  {
    value: 'outbound-epsilon',
    label: '↗ Epsilon',
    displayName: 'Outbound (Epsilon)',
    color: 'text.secondary',
    borderColor: 'text.secondary',
  },
  {
    value: 'outbound-mixpanel',
    label: '↗ Mixpanel',
    displayName: 'Outbound (Mixpanel)',
    color: 'text.secondary',
    borderColor: 'text.secondary',
  },
];

export const CRITICALITY_BADGES = {
  low: 'info.main',
  medium: 'success.main',
  high: 'warning.main',
  critical: 'error.main',
};

export const PRIORITY_BADGES = {
  P0: 'error.main',
  P1: 'warning.main',
  P2: 'success.main',
  P3: 'info.main',
};
